import { FormattedMessage } from 'react-intl';

interface FilterSubMenuAllItemsProps {
  setAllSelected: (selectedParentTagId, checked) => void;
  selectedParentTagId: number | null;
  checked: boolean;
}

export const FilterSubMenuAllItems: React.FC<FilterSubMenuAllItemsProps> = ({
  setAllSelected,
  selectedParentTagId,
  checked,
}) => {
  return (
    <li className="w-full py-5 border-b border-gray-200">
      <label
        htmlFor="selecAllCheckbox"
        className={`w-full flex items-center justify-between cursor-pointer text-black ${
          checked ? 'font-bold' : 'font-medium'
        }`}
      >
        <FormattedMessage id="Select all" />
        <input
          id="selecAllCheckbox"
          name="selecAllCheckbox"
          className="w-6 h-6 text-primary border-lightGrey focus:ring-transparent rounded-full cursor-pointer"
          type="checkbox"
          onChange={(e) => {
            setAllSelected(selectedParentTagId, e.target.checked);
          }}
          checked={checked}
        />
      </label>
    </li>
  );
};
